/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Modal, Popover } from 'antd';
import styled from 'styled-components';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { changePaymentDateTransfer } from '../../../services/repository/payrollRepository';
import { useUserPolicy } from '../../../user-policy';
import { getPaymentDateDisableReason } from './getPaymentDateDisableReason';

const H3NoMargin = styled.h3`
  margin: 0px;
`;

function ModalAnteciparRepasse({ onCloseModal, onPaymentAdvanceComplete, open, payroll }) {
  const [paymentDate, setPaymentDate] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const { userAccount } = useUserPolicy();

  useEffect(() => {
    if (open) {
      setPaymentDate(undefined);
    }
  }, [open]);

  const currentPaymentDate = payroll?.paymentDateAdjustedByManager || payroll?.dataPrevistaPagamentoCooperado;
  const { isAdmin } = userAccount;

  const resolveDisableReason = (current) =>
    getPaymentDateDisableReason({
      current,
      payroll,
      isAdmin,
    });

  const onPaymentAdvance = async () => {
    if (paymentDate && currentPaymentDate && paymentDate.isSame(currentPaymentDate, 'day')) {
      onCloseModal();
      return;
    }

    try {
      setLoading(true);
      await changePaymentDateTransfer(payroll.id, { paymentDate });
      await onPaymentAdvanceComplete(paymentDate);
      Modal.success({
        title: 'Solicitação recebida com Sucesso',
        content:
          'Para que o repasse ocorra na data solicitada é necessário que o crédito conste em conta até as 11:30 deste dia.',
      });
    } catch (err) {
      if (err.response.data.statusCode === 400) {
        Modal.error({
          title: 'Alteração de Pagamento Negado',
          content: err.response.data.message,
        });
      } else {
        mostrarErro(err);
      }
    } finally {
      setLoading(false);
    }
  };

  const renderDateCell = (current) => {
    const reason = resolveDisableReason(current);
    const inner = (
      <div
        className="ant-picker-cell-inner"
        style={reason ? { pointerEvents: 'auto', cursor: 'not-allowed' } : undefined}
      >
        {current.date()}
      </div>
    );

    if (!reason) {
      return inner;
    }

    return (
      <Popover
        content={reason}
        mouseEnterDelay={0.3}
        trigger={['hover', 'focus']}
        overlayStyle={{ zIndex: 1100 }}
      >
        {inner}
      </Popover>
    );
  };

  return (
    <Modal
      title="Solicitar Alteração de Pagamento"
      okText="Alterar"
      okButtonProps={{ disabled: !paymentDate }}
      cancelText="Cancelar"
      onOk={() => onPaymentAdvance()}
      onCancel={() => {
        if (!loading) onCloseModal();
      }}
      confirmLoading={loading}
      open={open}
    >
      <>
        <H3NoMargin>Selecione para qual data deseja que o pagamento seja alterado</H3NoMargin>
        <DatePicker
          allowClear={false}
          placeholder="DD/MM/YYYY"
          format="DD/MM/YYYY"
          value={paymentDate}
          disabledDate={(current) => !!resolveDisableReason(current)}
          dateRender={renderDateCell}
          onChange={(data) => setPaymentDate(data)}
          showToday={false}
        />
        <br />
        <br />
        <p>Cada requisição só pode ter o pagamento alterado uma vez por dia.</p>
      </>
    </Modal>
  );
}

ModalAnteciparRepasse.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onPaymentAdvanceComplete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  payroll: PropTypes.shape().isRequired,
};

export default ModalAnteciparRepasse;
